import { Mic, MonitorSpeaker, Square, Save, Library, PanelRightClose, PanelRightOpen, ALargeSmall } from "lucide-react";

export const LevelMeter = ({ level, color, active, testId }) => (
  <div className="flex items-end gap-[3px] h-4" data-testid={testId}>
    {[0.5, 0.8, 1, 0.7, 0.4].map((m) => (
      <span key={m} className="w-[3px] rounded-full transition-[height] duration-75"
        style={{ background: active ? color : "#334155", height: `${Math.max(15, active ? level * m * 100 : 15)}%` }} />
    ))}
  </div>
);

const Source = ({ icon: Icon, label, on, level, color, testId, onClick, compact }) => (
  <button onClick={onClick} data-testid={testId} title={label}
    className={`flex items-center gap-2 rounded-full border ${compact ? "px-2.5" : "px-3"} py-1.5 text-xs font-mono uppercase tracking-widest transition-colors duration-200 ${on ? "border-white/25 bg-white/10 text-white" : "border-white/15 text-slate-300 hover:text-white hover:border-white/30"}`}>
    <Icon size={14} style={{ color: on ? color : undefined }} />
    {!compact && label}
    <LevelMeter level={level} color={color} active={on} />
  </button>
);

const Tool = ({ icon: Icon, label, onClick, testId, compact }) => (
  <button onClick={onClick} data-testid={testId} title={label}
    className="flex items-center gap-1.5 rounded-full px-2.5 py-1.5 text-xs text-slate-300 hover:text-white hover:bg-white/10 transition-colors">
    <Icon size={15} /> {!compact && <span className="hidden xl:inline">{label}</span>}
  </button>
);

export const TopBar = ({ host, guest, live, onStart, onStop, onToggleHost, onToggleGuest, elapsed, compact, onToggleCompact, onSave, onLibrary, saving, textScale, onCycleText, headerRef }) => (
  <header ref={headerRef} className={`flex items-center justify-between ${compact ? "flex-nowrap gap-1 px-2 py-2" : "flex-wrap gap-2 px-4 py-3"} rounded-2xl card-surface sticky top-2 z-20`} data-testid="interview-topbar">
    <div className="flex items-center gap-3 min-w-0">
      {!compact && (
        <div className="min-w-0">
          <h1 className="font-display text-lg font-bold tracking-tight leading-none">Interview Assistant</h1>
          <p className="eyebrow mt-1">Follow-up co-pilot</p>
        </div>
      )}
      <div className="flex items-center">
        <Tool icon={Save} label={saving ? "Saving..." : "Save"} onClick={onSave} testId="save-interview-button" compact={compact} />
        <Tool icon={Library} label="Saved" onClick={onLibrary} testId="open-library-button" compact={compact} />
        <Tool icon={compact ? PanelRightOpen : PanelRightClose} label={compact ? "Full layout" : "Side window"} onClick={onToggleCompact} testId="compact-toggle-button" compact={compact} />
        <Tool icon={ALargeSmall} label={`Text ${({ 1: "L", 1.12: "XL", 0.9: "M" })[textScale] || "L"}`} onClick={onCycleText} testId="text-size-button" compact={compact} />
      </div>
    </div>
    <div className={`flex items-center ${compact ? "gap-1" : "flex-wrap gap-2"}`}>
      <Source icon={Mic} label="You" on={host.active} level={host.active ? 0.6 : 0} color="#38bdf8" testId="toggle-host-mic" onClick={onToggleHost} compact={compact} />
      <Source icon={MonitorSpeaker} label="Guest" on={guest.active} level={guest.level} color="#10b981" testId="toggle-guest-audio" onClick={onToggleGuest} compact={compact} />
      {live && <span className="flex items-center gap-2 font-mono text-xs text-slate-200 px-2" data-testid="live-timer"><span className="h-2 w-2 rounded-full bg-rose-500 animate-pulse" /> {elapsed}</span>}
      {live ? (
        <button onClick={onStop} data-testid="stop-listening-button" className={`flex items-center gap-2 rounded-full bg-rose-500/90 hover:bg-rose-500 text-white ${compact ? "px-3" : "px-4"} py-2 text-sm font-semibold transition-colors`}><Square size={14} /> Stop</button>
      ) : (
        <button onClick={onStart} data-testid="start-listening-button" className={`flex items-center gap-2 rounded-full bg-sky-400 hover:bg-sky-300 text-[#070F1E] ${compact ? "px-3" : "px-4"} py-2 text-sm font-semibold transition-colors`}>
          <Mic size={14} /> {compact ? <span className="hidden min-[460px]:inline">Start</span> : <><span className="hidden sm:inline">Start listening</span><span className="sm:hidden">Start</span></>}
        </button>
      )}
    </div>
  </header>
);
